@if (hasAccess) {
  <div class="header">
    <div class="header__col-left md-hidden"></div>

    <div class="header__col-center">
      <div class="header__branding">
        <div class="header__branding-logo">
          <img
            [alt]="'header.logoAlt' | translate"
            src="/images/CVX-Logo.png"
            class="header__logo-img" />
        </div>
        <div class="header__branding-project">
          <a
            class="swd-link"
            href="/">
            {{ 'app.title' | translate }}
          </a>
        </div>
      </div>
    </div>

    <div class="header__col-right md-hidden">
      <div class="header__user">
        <img
          [alt]="'header.userAvatarAlt' | translate"
          src="/images/no-avatar.png"
          class="header__user-avatar" />
        <span class="header__user-name">{{ fullName || ('header.unknownUser' | translate) }}</span>
      </div>
    </div>
  </div>
}
